import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  loading: false,
  result: {},
  error: false,
  success: false,
});

export const { Creators, Types } = createActions({
  createResultPlanRequested: ['resultData'],
  createResultPlanSuccess: ['result'],
  createResultPlanError: ['error'],
  retrievePlanRequested: ['data'],
  retrievePlanSuccess: ['result'],
  retrievePlanError: ['error'],
  fetchPlanRequested: ['data'],
  fetchPlanSuccess: ['data'],
  fetchPlanError: ['error'],
});

export const Selectors = {
  // Selector will be here...
};



export const Reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_RESULT_PLAN_REQUESTED]: state => state.merge({ loading: true, }),
  [Types.CREATE_RESULT_PLAN_SUCCESS]: (state, result) => state.merge({ ...result, loading: false, success: true, error: false, }),
  [Types.CREATE_RESULT_PLAN_ERROR]: (state) => state.merge({ loading: false, error: true, success: false, }),
  [Types.RETRIEVE_PLAN_REQUESTED]: state => state.merge({ loading: true }),
  [Types.RETRIEVE_PLAN_SUCCESS]: (state, result) => state.merge({ ...result, loading: false, success: true, error: false, }),
  [Types.RETRIEVE_PLAN_ERROR]: (state) => state.merge({ loading: false, error: true, success: false, }),
  [Types.FETCH_PLAN_REQUESTED]: (state) => state.merge({loading: true, error: false,}),
  [Types.FETCH_PLAN_SUCCESS]: (state, result) => state.merge({result, error: false, loading: false, success: true,}),
  [Types.FETCH_PLAN_ERROR]: (state) => state.merge({loading: false, error: true,}),
});
